export default function HighPriceGuarantee() {
  const features = [
    {
      icon: 'gold-bar',
      title: '業界最高水準の買取価格',
      description: '海外バイヤーとの直接取引により、中間マージンを削減。国内相場を大きく上回る買取価格を実現しています。',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '円安メリットを最大活用',
      description: '現在の円安相場を活かし、海外市場での高値取引を実現。お客様により多くの利益を還元いたします。',
    },
    {
      icon: 'ri-search-eye-line',
      title: '専門鑑定士による査定',
      description: '経験豊富な鑑定士が一点一点丁寧に査定。真の価値を見極め、適正な価格をご提示いたします。',
    },
    {
      icon: 'yen',
      title: '即日現金化可能',
      description: '査定額にご納得いただければ、その場で現金でお支払い。お急ぎの方も安心してご利用いただけます。',
    },
  ];

  const examples = [
    {
      item: '江戸時代の日本刀',
      price: '500,000円〜',
      note: '鑑定書・保存状態良好',
    },
    {
      item: '戦国時代の甲冑',
      price: '800,000円〜',
      note: '完品・江戸時代',
    },
    {
      item: '変わり兜',
      price: '300,000円〜',
      note: '前立て付き・希少品',
    },
  ];

  return (
    <section id="guarantee" className="py-20 lg:py-28 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-block bg-samurai-red/10 px-6 py-2 rounded-full mb-6">
            <p className="text-samurai-red font-bold text-base lg:text-lg whitespace-nowrap">GUARANTEE</p>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black text-samurai-dark mb-6 font-serif">
            高価買取保証
          </h2>
          <p className="text-xl lg:text-2xl text-samurai-gray max-w-3xl mx-auto leading-relaxed">
            <strong>専門知識</strong>と<strong>豊富な経験</strong>で、お客様の大切な品を適正価格で買取いたします
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 lg:p-10 shadow-lg border-2 border-gray-100 hover:border-samurai-gold transition-all duration-300"
            >
              <div className="w-16 h-16 bg-samurai-gold/20 rounded-full flex items-center justify-center mb-6">
                {feature.icon === 'gold-bar' ? (
                  <i className="ri-copper-coin-line text-4xl text-samurai-gold"></i>
                ) : feature.icon === 'yen' ? (
                  <span className="text-4xl font-black text-samurai-gold">￥</span>
                ) : (
                  <i className={`${feature.icon} text-4xl text-samurai-gold`}></i>
                )}
              </div>
              <h3 className="text-2xl lg:text-3xl font-black text-samurai-dark mb-4 font-serif whitespace-nowrap">
                {feature.title}
              </h3>
              <p className="text-lg lg:text-xl text-samurai-gray leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-xl border-2 border-samurai-gold">
          <h3 className="text-3xl lg:text-4xl font-black text-samurai-dark mb-8 text-center font-serif whitespace-nowrap">
            買取価格例
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            {examples.map((example, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-samurai-red/5 to-samurai-gold/5 rounded-xl p-6 lg:p-8 border-2 border-samurai-gold/30"
              >
                <h4 className="text-xl lg:text-2xl font-bold text-samurai-dark mb-3 whitespace-nowrap">
                  {example.item}
                </h4>
                <p className="text-3xl lg:text-4xl font-black text-samurai-red mb-3 font-serif whitespace-nowrap">
                  {example.price}
                </p>
                <p className="text-base lg:text-lg text-samurai-gray">
                  {example.note}
                </p>
              </div>
            ))}
          </div>
          <p className="text-base lg:text-lg text-samurai-gray text-center mt-8">
            ※上記は一例です。実際の買取価格は品物の状態、時代、作者などにより異なります。
          </p>
        </div>

        <div className="mt-16 bg-gradient-to-r from-samurai-gold/20 to-samurai-gold/10 rounded-2xl p-8 lg:p-12 border-2 border-samurai-gold">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="w-20 h-20 flex items-center justify-center flex-shrink-0">
              <i className="ri-medal-line text-6xl text-samurai-gold"></i>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-2xl lg:text-3xl font-black text-samurai-dark mb-3 whitespace-nowrap">
                他店より1円でも高く買取
              </h3>
              <p className="text-lg lg:text-xl text-samurai-gray leading-relaxed">
                他店の査定額をお持ちの方は、ぜひご相談ください。<strong>可能な限り高価買取</strong>させていただきます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
